<!-- @format -->

<template>
  <div v-if="isImpersonating" class="impersonation-banner">
    <div class="impersonation-banner__content">
      <span class="impersonation-banner__text">
        {{ 'Logged in as:' | translate }} <strong>{{ impersonatedUserName }}</strong>
        <a href="javascript:void(0)" @click="exitImpersonation" class="impersonation-banner__exit">
          {{ 'Exit Impersonation' | translate }}
        </a>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { GET_EXIT_IMPERSONATION } from '../store/types';

export default {
  name: 'ImpersonationBanner',

  computed: {
    ...mapState('users', ['isImpersonating', 'user']),
    impersonatedUserName() {
      if (!this.user) return '';
      return `${this.user.firstName} ${this.user.lastName}`.trim();
    },
  },

  methods: {
    ...mapActions('users', [GET_EXIT_IMPERSONATION]),
    async exitImpersonation() {
      try {
        await this[GET_EXIT_IMPERSONATION]();
      } catch (error) {
        console.error('Error exiting impersonation:', error);
      }
    },
  },
};
</script>

<style scoped>
.impersonation-banner {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  background: #ffdb58;
  color: white;
  padding: 13px 20px 7px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.impersonation-banner__content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.impersonation-banner__text {
  color: #000000;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.impersonation-banner__text strong {
  font-weight: 700;
  margin-left: 5px;
}

.impersonation-banner__exit {
  color: white;
  padding: 6px 16px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s ease;
  color: #0000ff;
}

.impersonation-banner__exit:hover {
  color: white;
}

.impersonation-banner__exit:active {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* Responsive */
@media (max-width: 768px) {
  .impersonation-banner {
    padding: 10px 15px;
  }

  .impersonation-banner__content {
    flex-direction: column;
    text-align: center;
    gap: 8px;
  }

  .impersonation-banner__text {
    font-size: 14px;
  }

  .impersonation-banner__exit {
    width: 100%;
    text-align: center;
  }
}
</style>
